import React, { useContext, useState } from 'react';
import Tooltip from '@mui/material/Tooltip';
import './interviewmanagementvet.css';
import ArrowBack from '@mui/icons-material/ArrowBack';
import { useLocation, useNavigate } from 'react-router-dom';
import { UserTypeContext } from "../../AppRoute";
import ManageJd from '../../components/managejobdesc/managejd';

const InterviewManagementVet = () => {
    const location = useLocation();
    const { userType, userRecords } = useContext(UserTypeContext);
    const userRecruitmentpartnerId =
        userType === "Admin"
            ? location?.state?.recruitmentPartnerId
            : userRecords?.recruitmentpartnerId;
    const idContextTest =
        userType === "Admin" ? location?.state?.id : userRecords?.id;
    const userRole =
        userType === "Admin"
            ? location?.state?.userRole
            : userRecords?.role?.roleName;
    const userRecordData =
        userType === "Admin" ? location?.state?.userRecords : userRecords;
    const history = useNavigate();
    const gotoDashBoard = () => {
        history("/dashboard",
            {
                state: {
                    userType: userType,
                    recruitmentPartnerId: userRecruitmentpartnerId,
                    id: idContextTest,
                    userRecords: userRecordData,
                    roleName: userRole,
                },
            });
    };

    return (
        <div className="interview_management_container">
            <div className="topContainer_interview_management">
                <div className='mainDiv_interview_management'>
                    <div className="reportHeader_interview_management">
                        <Tooltip title="Go Back to Dashboard" placement="bottom">
                            <div className="goBackButton_interview_management" onClick={(e) => gotoDashBoard()}>
                                <ArrowBack sx={{ fontSize: 20 }} />
                            </div>
                        </Tooltip>
                        <div className="reportTitle_interview_management">VET Management</div>
                    </div>
                    <div className="gridContainer_interview_management">
                        <div className="kendoContainer_interview_management">
                            <ManageJd />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InterviewManagementVet;